module.exports = __webpack_public_path__ + "static/media/envelope-open.0dd9a658.svg";